var map = {
	"./Primary5.svg": "./src/assets/images/avatars/start/Primary5.svg",
	"./Secondary5.svg": "./src/assets/images/avatars/start/Secondary5.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/avatars/start sync recursive ^\\.\\/.*5\\.svg$";